import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { environment } from '../../environments/environment';
import { ConfiniComuniResponse, ComuneFeature, ComuneGeoJsonUtils, ComuniFeatureCollection } from '../models/comune-geojson.model';
import { Comune } from '../models/comune.model';

@Injectable({
  providedIn: 'root'
})
export class ComuniService {
  private apiUrl = environment.apiUrl + "/comune"; // URL base per le API dei comuni

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
  ) { }

  get(): Observable<Comune[]> {
    return this.http.get<Comune[]>(this.apiUrl);
  }

  /**
   * Ottiene i confini GeoJSON dei comuni
   * @returns Observable con i dati GeoJSON
   */
  getConfiniComuni(): Observable<ComuniFeatureCollection> {
    const url = `${this.apiUrl}/confini`;

    // this.logger.info('[COMUNI] Recupero confini comuni');

    return this.http.get<ConfiniComuniResponse>(url).pipe(
      map(response => {
        // this.logger.info('[COMUNI] Confini comuni recuperati con successo');
        return ComuneGeoJsonUtils.toFeatureCollection(response);
      }),
      catchError(error => {
        this.logger.error('[COMUNI] Errore nel recupero dei confini comuni', error);
        return throwError(() => new Error('Errore nel recupero dei confini comuni'));
      })
    );
  }
  getConfiniComuniPerAnno(anno: number): Observable<ComuniFeatureCollection> {
    const url = `${this.apiUrl}/confini?anno=${anno}`;

    // this.logger.info('[COMUNI] Recupero confini comuni');

    return this.http.get<ConfiniComuniResponse>(url).pipe(
      map(response => {
        // this.logger.info('[COMUNI] Confini comuni recuperati con successo');
        return ComuneGeoJsonUtils.toFeatureCollection(response);
      }),
      catchError(error => {
        this.logger.error('[COMUNI] Errore nel recupero dei confini comuni', error);
        return throwError(() => new Error('Errore nel recupero dei confini comuni'));
      })
    );
  }

  /**
   * Ottiene i confini di un singolo comune
   * @param id ID del comune
   * @returns Observable con il Feature GeoJSON del comune
   */
  getConfineComune(id: number): Observable<ComuneFeature | null> {
    return this.getConfiniComuni().pipe(
      map(featureCollection => {
        const comune = featureCollection.features.find(
          feature => feature.properties.id === id
        );

        if (!comune) {
          this.logger.warn(`[COMUNI] Comune con ID ${id} non trovato`);
          return null;
        }

        // this.logger.info(`[COMUNI] Recuperato confine del comune: ${comune.properties.denominazione}`);
        return comune;
      })
    );
  }

  /**
   * Ottiene i comuni nella Valle di Susa
   * @returns Observable con FeatureCollection dei comuni nella Valle di Susa
   */
  getComuniValleDiSusa(): Observable<ComuniFeatureCollection> {
    // Nota: questo è un esempio, in una implementazione reale
    // si potrebbe fare una chiamata specifica o filtrare i risultati in base a un criterio
    return this.getConfiniComuni().pipe(
      map(featureCollection => {
        // Qui si potrebbero filtrare i comuni per una lista predefinita
        // o per coordinate che rientrano nella Valle di Susa
        // this.logger.info('[COMUNI] Filtrati comuni della Valle di Susa');
        return featureCollection;
      })
    );
  }
}
